export class RefundConfirmationDialogModel {
  size?: string;
  cancelButtonText?: string;
  okButtonText!: string;
}
